export default __webpack_public_path__ + "static/media/Pop.7b7c8715.mp3";